import React, { useEffect, useMemo } from "react";
import { Modal } from "react-bootstrap";
import { shallowEqual, useSelector } from "react-redux";
import { StateStatusCssClasses } from "../StatesUIHelpers";
import { useStatesUIContext } from "../StatesUIContext";

const selectedStates = (entities, ids) => {
  const _states = [];
  ids.forEach((id) => {
    const state = entities.find((el) => el.id === id);
    if (state) {
      _states.push(state);
    }
  });
  return _states;
};

export function StatesFetchDialog({ show, onHide }) {
  // States UI Context
  const statesUIContext = useStatesUIContext();
  const statesUIProps = useMemo(() => {
    return {
      ids: statesUIContext.ids,
      queryParams: statesUIContext.queryParams,
    };
  }, [statesUIContext]);

  // States Redux state
  const { states } = useSelector(
    (state) => ({
      states: selectedStates(state.states.entities, statesUIProps.ids),
    }),
    shallowEqual
  );

  // if there weren't selected ids we should close modal
  useEffect(() => {
    if (!statesUIProps.ids || statesUIProps.ids.length === 0) {
      onHide();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [statesUIProps.ids]);

  return (
    <Modal
      show={show}
      onHide={onHide}
      aria-labelledby="example-modal-sizes-title-lg"
    >
      <Modal.Header closeButton>
        <Modal.Title id="example-modal-sizes-title-lg">
          Fetch selected elements
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="list-timeline list-timeline-skin-light padding-30">
          <div className="list-timeline-items">
            {states.map((state) => (
              <div className="list-timeline-item mb-3" key={state.id}>
                <span className="list-timeline-text">
                  <span
                    className={`label label-lg label-light-${
                      StateStatusCssClasses[state.status]
                    } label-inline`}
                    
                  >
                    ID: {state.id}
                  </span>{" "}
                  <span className={`label label-lg label-light-${
                      StateStatusCssClasses[state.status]
                    } label-inline`}>
                    name : {state.name}
                  </span>
                </span>
              </div>
            ))}
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <div>
          <button
            type="button"
            onClick={onHide}
            className="btn btn-light btn-elevate"
          >
            Cancel
          </button>
          <> </>
          <button
            type="button"
            onClick={onHide}
            className="btn btn-primary btn-elevate"
          >
            Ok
          </button>
        </div>
      </Modal.Footer>
    </Modal>
  );
}
